import { NgModule } from '@angular/core';
import { ModalModule } from '@michelin/theme';
import { HspModalContainerDirective } from './hsp-modal-container.directive';
import { HspModalWrapperComponent } from './hsp-modal-wrapper.component';

@NgModule({
    imports: [ModalModule],
    declarations: [HspModalWrapperComponent, HspModalContainerDirective],
    exports: [HspModalWrapperComponent, HspModalContainerDirective],
})
export class HspModalModule {}
